import { motion, AnimatePresence } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrophy, faTimes } from '@fortawesome/free-solid-svg-icons';

export default function AchievementCelebration({ achievement, onClose }) {
  const getBadgeIcon = (type) => {
    switch (type) {
      case 'streak': return '🔥';
      case 'first-time': return '⭐';
      case 'count': return '📊';
      default: return '🏆';
    }
  };

  return (
    <AnimatePresence>
      <div className="fixed inset-0 bg-black/70 z-[100] flex items-center justify-center p-4">
        <motion.div
          initial={{ scale: 0.5, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.5, opacity: 0 }}
          className="bg-white rounded-2xl p-8 max-w-md w-full text-center relative"
        >
          <button
            onClick={onClose}
            className="absolute top-4 right-4 p-2 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <FontAwesomeIcon icon={faTimes} className="text-text-secondary" />
          </button>

          {/* Celebration Animation */}
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: [0, 1.2, 1] }}
            transition={{ duration: 0.5 }}
            className="text-8xl mb-4"
          >
            {getBadgeIcon(achievement.type)}
          </motion.div>

          <motion.h2
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.2 }}
            className="text-3xl font-bold text-text-primary mb-2"
          >
            Achievement Unlocked!
          </motion.h2>

          <motion.p
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.3 }}
            className="text-xl font-semibold text-primary mb-4"
          >
            {achievement.title}
          </motion.p>

          <motion.p
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.4 }}
            className="text-text-secondary mb-6"
          >
            Congratulations on reaching this milestone! 🎉
          </motion.p>

          <motion.button
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.5 }}
            onClick={onClose}
            className="w-full px-6 py-3 bg-primary text-white rounded-lg font-semibold hover:bg-primary-dark transition-colors"
          >
            Continue
          </motion.button>

          {/* Confetti Effect */}
          {[...Array(20)].map((_, i) => (
            <motion.div
              key={i}
              initial={{ 
                x: '50%',
                y: '50%',
                opacity: 1,
                scale: 1
              }}
              animate={{
                x: `${50 + (Math.random() - 0.5) * 200}%`,
                y: `${50 + (Math.random() - 0.5) * 200}%`,
                opacity: 0,
                scale: 0
              }}
              transition={{
                duration: 2,
                delay: Math.random() * 0.5
              }}
              className="absolute text-2xl"
              style={{
                left: '50%',
                top: '50%'
              }}
            >
              🎉
            </motion.div>
          ))}
        </motion.div>
      </div>
    </AnimatePresence>
  );
}
